/* eslint-disable */
//短信验证码激活
export const SEND_PHONE_CODE = 'SEND_PHONE_CODE'; //发送验证码
export const SEND_PHONE_CODE_END = 'SEND_PHONE_CODE_END'; //验证码等待时间结束
export const SEND_PHONE_MSG = 'SEND_PHONE_MSG'; //发送等待时间
//提交
export const ACTIVE_SEND_PHONE = 'ACTIVE_SEND_PHONE'; //提交状态
export const ACTIVE_SEND_SUCCESS = 'ACTIVE_SEND_SUCCESS'; //发送成功
export const ACTIVE_SEND_ERR = 'ACTIVE_SEND_ERR'; //发送失败
